import React from "react";
import ViewsLoading from "theme/views/ViewsLoading";
import loadable from "@loadable/component";

const options = {
    fallback: <ViewsLoading />,
};

const SignedIn = loadable(() => import("./SignedIn"), options);

export const templates = {
    default: SignedIn,
    my_account_orders: SignedIn,
    my_account_account_settings: SignedIn,
    my_account_wishlists: SignedIn,
    my_account_membership: SignedIn,
    my_account_promotions: SignedIn,
    my_account_register_page: loadable(() => import("./Register"), options),
    my_account_store_sign_up: loadable(() => import("./StoreSignUp"), options),
};
